module.exports = __webpack_public_path__ + "static/media/carlos_lineu_de_faria_e_alves.22aaea37.png";